/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const findBatchesByMonth = /* GraphQL */ `query FindBatchesByMonth($month: Int, $year: Int) {
  findBatchesByMonth(month: $month, year: $year) {
    day_bucket_date
    status
    user_id
    number_of_transactions
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchesByMonthQueryVariables,
  APITypes.FindBatchesByMonthQuery
>;
export const findBatchJobsByMonth = /* GraphQL */ `query FindBatchJobsByMonth($month: Int, $year: Int) {
  findBatchJobsByMonth(month: $month, year: $year) {
    day_bucket_date
    status
    user_id
    number_of_transactions
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchJobsByMonthQueryVariables,
  APITypes.FindBatchJobsByMonthQuery
>;
export const findBatchesWithStatusesInLastMonths = /* GraphQL */ `query FindBatchesWithStatusesInLastMonths(
  $statuses: [String]
  $offsetInHours: Int
) {
  findBatchesWithStatusesInLastMonths(
    statuses: $statuses
    offsetInHours: $offsetInHours
  ) {
    day_bucket_date
    status
    user_id
    number_of_transactions
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchesWithStatusesInLastMonthsQueryVariables,
  APITypes.FindBatchesWithStatusesInLastMonthsQuery
>;
export const findMissingAsyncResponses = /* GraphQL */ `query FindMissingAsyncResponses {
  findMissingAsyncResponses {
    entry_id
    enrichment_event
    job_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindMissingAsyncResponsesQueryVariables,
  APITypes.FindMissingAsyncResponsesQuery
>;
export const findLocalClearanceDeadQMessages = /* GraphQL */ `query FindLocalClearanceDeadQMessages($originQueueName: String) {
  findLocalClearanceDeadQMessages(originQueueName: $originQueueName) {
    items {
      uuid
      originQueueName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindLocalClearanceDeadQMessagesQueryVariables,
  APITypes.FindLocalClearanceDeadQMessagesQuery
>;
